<form class="f-col blank-form" [formGroup]="departmentForm" (ngSubmit)="onSave()">
    <div class="section-heading">
        <h2 class="h2-heading">{{content?.['b2b.managecompany.department']}} <div class="dot">.</div> <span
                class="optional">{{content?.['b2b.managecompany.optional']}}</span></h2>
        <a role="button" class="link"
            *ngIf="commonObjPipes?.GetAllDetails?.pipe?.length > 0 && !Addnew" (click)="addNewDepartment()"><mat-icon fontSet="material-symbols-outlined"
                class="edit-icon">add</mat-icon>{{content?.['b2b.managecompany.addnew']}}</a>
    </div>

    <div class="section-content" *ngIf="Addnew">
        <div class="inner-contentsection">
            <div class="f-row">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.selectofficelocation']}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix>{{ branchSelect.panelOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                        <mat-select #branchSelect formControlName="selectBranch">
                            <mat-option *ngFor="let branch of commonObjPipes.GetAllBranch.pipe" [value]="branch.corpBranchId"> {{branch.corpBranchName}} </mat-option>
                        </mat-select>
                        <mat-error *ngIf="departmentForm.get('selectBranch')?.hasError('required') && departmentForm.get('selectBranch')?.touched"> {{dictionaryContent?.['b2b.managetraveler.officelocreq'] || 'Office location is required.'}}</mat-error>
                    </mat-form-field> 
                </div>
            </div>
            <div class="f-row">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.tpdepartmentname']}}</mat-label>
                        <input matInput formControlName="nemeOfTheDepartment"
                            (keypress)="_CommonService.allowAlphanumericOnly($event)"
                            (paste)="_CommonService.onPasteBlocked($event)"
                            (contextmenu)="_CommonService.disableRightClick($event)">
                        <mat-error *ngIf="departmentForm.get('nemeOfTheDepartment')?.hasError('required')">{{dictionaryContent?.['b2b.managecompany.departmentnamereq']}}</mat-error>
                        <mat-error *ngIf="departmentForm.get('nemeOfTheDepartment')?.hasError('maxlength')">{{dictionaryContent?.['b2b.managecompany.departmentnamemaxlimit']}}</mat-error>
                        <mat-error *ngIf="departmentForm.get('nemeOfTheDepartment')?.hasError('minlength')">{{dictionaryContent?.['b2b.managecompany.departnameminlimit']}}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field [class.mat-has-not-value]="!departmentForm.value.departmentEmail">
                        <mat-label>{{content?.['b2b.managecompany.tpdepartmentemail']}} ({{content?.['b2b.managecompany.optional']}})</mat-label>
                        <input matInput formControlName="departmentEmail"
                            (paste)="_CommonService.onPasteBlocked($event)"
                            (contextmenu)="_CommonService.disableRightClick($event)"
                            (keypress)="_CommonService.blockInvalidCharactersForEmail($event)" data-dd-privacy="mask">
                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="filled">mail</mat-icon>
                        <mat-error *ngIf="departmentForm.get('departmentEmail')?.hasError('required')">{{content?.['b2b.managecompany.departmentemailrequired'] || 'Department email is required'}}</mat-error>
                        <mat-error
                            *ngIf="departmentForm.get('departmentEmail')?.hasError('email') || departmentForm.get('departmentEmail')?.hasError('pattern')">{{dictionaryContent?.['b2b.managetraveler.entervalidemail']}}</mat-error>
                        <mat-error *ngIf="departmentForm.get('departmentEmail')?.hasError('minlength')">{{dictionaryContent?.['b2b.managecompany.emaillength']}} </mat-error>
                        <mat-error *ngIf="departmentForm.get('departmentEmail')?.hasError('maxlength')">{{dictionaryContent?.['b2b.managecompany.emailcannotexceed']}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="f-col">
                    <mat-form-field [class.mat-has-not-value]="!departmentForm.value.departmentphoneNo">
                        <mat-label>{{content?.['b2b.managecompany.tpdepartmentphone']}} ({{content?.['b2b.managecompany.optional']}})</mat-label>
                        <input matInput formControlName="departmentphoneNo" (keypress)="allowedNumberOnly($event)"
                            (keypress)="_CommonService.blockInvalidCharacters($event)"
                            (paste)="_CommonService.onPasteBlocked($event)"
                            (contextmenu)="_CommonService.disableRightClick($event)" data-dd-privacy="mask">
                        <mat-icon fontSet="material-symbols-outlined" matSuffix>phone_android</mat-icon>
                        <mat-error *ngIf="departmentForm.get('departmentphoneNo')?.hasError('minlength')"> {{dictionaryContent?.['b2b.managecompany.cannotexceedmobilenumber']}}</mat-error>
                        <mat-error *ngIf="departmentForm.get('departmentphoneNo')?.hasError('maxlength')"> {{dictionaryContent?.['b2b.managecompany.cannotexceedmobilenumber']}}</mat-error>
                        <mat-error *ngIf="departmentForm.get('departmentphoneNo')?.hasError('required')">{{content?.['b2b.managecompany.departmentphonerequired'] || 'Department Phone number is required'}} </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.tpdepartmentfax']}} ({{content?.['b2b.managecompany.optional']}})</mat-label>
                        <input matInput formControlName="departmentFax"
                            (keypress)="_CommonService.blockInvalidCharacters($event)"
                            (paste)="_CommonService.onPasteBlocked($event)"
                            (contextmenu)="_CommonService.disableRightClick($event)">
                        <mat-error *ngIf="departmentForm.get('departmentFax')?.hasError('required')">Department Fax is
                            required</mat-error>
                        <mat-error *ngIf="departmentForm.get('departmentFax')?.hasError('pattern')">Fax number must
                            contain only digits and be between 7 to 12 digits long.</mat-error>
                        <mat-error *ngIf="departmentForm.get('departmentFax')?.hasError('minlength')">Fax number must be
                            at least 7 digits.</mat-error>
                        <mat-error *ngIf="departmentForm.get('departmentFax')?.hasError('maxlength')">Fax number cannot
                            exceed 15 digits.</mat-error>
                    </mat-form-field>
                </div>
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.tptravelbudget']}} ({{content?.['b2b.managecompany.optional']}})</mat-label>
                        <input matInput formControlName="travellerBudget"
                            (keypress)="_CommonService.blockInvalidCharacters($event)"
                            (paste)="_CommonService.onPasteBlocked($event)"
                            (contextmenu)="_CommonService.disableRightClick($event)"
                            (keypress)="allowedNumberOnly($event)">
                        <mat-error *ngIf="departmentForm.get('travellerBudget')?.hasError('required')">Travel Budget is
                            required.</mat-error>
                        <mat-error *ngIf="departmentForm.get('travellerBudget')?.hasError('maxlength')">Travel Budget
                            cannot exceed more than 10 length.</mat-error>
                    </mat-form-field>
                </div>
            </div> -->

            <!-- <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.tpnoofstaff']}} ({{content?.['b2b.managecompany.optional']}})</mat-label>
                        <input matInput formControlName="numberOfStaff"
                            (keypress)="_CommonService.blockInvalidCharacters($event)"
                            (paste)="_CommonService.onPasteBlocked($event)"
                            (contextmenu)="_CommonService.disableRightClick($event)"
                            (keypress)="allowedNumberOnly($event)">
                        <mat-error *ngIf="departmentForm.get('numberOfStaff')?.hasError('required')">Number of Staff is
                            required.</mat-error>
                        <mat-error *ngIf="departmentForm.get('numberOfStaff')?.hasError('maxlength')">Number of Staff
                            cannot exceed more than 7 length.</mat-error>

                    </mat-form-field>
                </div>
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.omfnooftraveler']}} ({{content?.['b2b.managecompany.optional']}})</mat-label>
                        <input matInput formControlName="numberOfTravellers"
                            (keypress)="_CommonService.blockInvalidCharacters($event)"
                            (paste)="_CommonService.onPasteBlocked($event)"
                            (contextmenu)="_CommonService.disableRightClick($event)"
                            (keypress)="allowedNumberOnly($event)">
                        <mat-error *ngIf="departmentForm.get('numberOfTravellers')?.hasError('required')">Number of
                            Travelers is required.</mat-error>
                        <mat-error *ngIf="departmentForm.get('numberOfTravellers')?.hasError('maxlength')">Number of
                            Travelers cannot exceed more than 7 length.</mat-error>
                    </mat-form-field>
                </div>
            </div> -->

            <div class="f-row">
                <div class="f-col">
                    <mat-form-field [class.mat-has-not-value]="!departmentForm.value.selectHeadOfDepartment">
                        <mat-label>{{content?.['b2b.managecompany.tpselectheaddepart']}} ({{content?.['b2b.managecompany.optional']}})</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix >{{ branchSelect3.panelOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                        <mat-select #branchSelect3 formControlName="selectHeadOfDepartment" data-dd-privacy="mask">
                            <mat-option *ngFor="let headDept of commonObjPipes.GetAllHeadDepartment.pipe"
                                [value]="headDept.userId"> {{headDept.userName}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="departmentForm.get('selectHeadOfDepartment')?.hasError('required')">{{content?.['b2b.managecompany.headdepartmentrequired'] || 'Head of Department is required.'}}</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="inner-action">
            <button mat-button class="button--secondary-small"
                (click)="onCancel()">{{content?.['b2b.managecompany.cancel']}}</button>
            <button mat-button class="button--primary-small"
                [class.disabled]="departmentForm.invalid || departmentForm.pristine">{{content?.['b2b.managecompany.save']}}</button>
        </div>
    </div>

    <div class="section-table data-listing" *ngIf="commonObjPipes.GetAllDetails.pipe.length>0 && !Addnew">
        <table mat-table [dataSource]="commonObjPipes.GetAllDetails.pipe" class="mat-elevation-z0">
            <!-- Position Column -->
            <ng-container matColumnDef="Department">
                <th mat-header-cell *matHeaderCellDef>{{content?.['b2b.managecompany.department']}}</th>
                <td mat-cell *matCellDef="let element"> {{getValueOrEmpty(element.departmentName)}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="Department Email">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.tpdepartmentemail']}} </th>
                <td mat-cell *matCellDef="let element" data-dd-privacy="mask"> {{getValueOrEmpty(element.departmentEmail)}} </td>
            </ng-container>

            <ng-container matColumnDef="Department Phone">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.tpdepartmentphone']}} </th>
                <td mat-cell *matCellDef="let element" data-dd-privacy="mask"> {{getValueOrEmpty(element.departmentPhoneNo)}} </td>
            </ng-container>

            <ng-container matColumnDef="Branch">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.emaildomainlist'][2]?.Phrase}}
                </th>
                <td mat-cell *matCellDef="let element"> {{element.corpbranchName}} </td>
            </ng-container>

            <ng-container matColumnDef="Department Head Name">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.tpdepartheadname']}} </th>
                <td mat-cell *matCellDef="let element" data-dd-privacy="mask"> {{getValueOrEmpty(element.username)}} </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="Action">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.ddactions']}} </th>
                <td mat-cell *matCellDef="let element" class="onclick-links">
                    <a tabindex="0" role="button" aria-label="Edit item" class="onclick-cell primary-link" (keydown.enter)="onEdit(element)" (click)="onEdit(element)"><mat-icon fontSet="material-symbols-outlined">Edit</mat-icon></a>
                    <a tabindex="0" role="button" aria-label="Remove item" class="onclick-cell warm-link" (keydown.enter)="onRemove(element)" (click)="onRemove(element)"><mat-icon fontSet="material-symbols-outlined">Delete</mat-icon></a>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <ng-container *ngIf="!isLoading && commonObjPipes.GetAllDetails.pipe.length==0 && !Addnew">
        <app-cam-empty-state (myEvent)="handleEvent($event)" [heading]="content?.['b2b.managecompany.tpnodepartmenttitle'] || 'No department added'"
            [content]="content?.['b2b.managecompany.tpnodepartmentdesc'] || 'Add department details to streamline policy and approval workflows.'"
            [navigateTo]="'/cam/company-management/department'">
        </app-cam-empty-state>
    </ng-container>
</form>

<ng-template #selectionWarning>
    <div class="custom-dialog">
        <div class="d-justify-bw">
            <div class="custom-dialog__left">
                <div class="mat-dialog-title custom-dialog__title d-justify-bw">
                    <h2 class="mat-dialog-title"> {{content?.warningList[0]?.title}}</h2>
                    <!-- <div class="custom-overlay-close">
                        <mat-icon fontSet="material-symbols-outlined" class="close_icon" (click)="CloseDialog(false)">close</mat-icon>
                    </div> -->
                </div>
                <mat-dialog-content class="custom-dialog__text">
                    <div class="custom-dialog__description">Are you sure you want to remove this Department?</div>
                </mat-dialog-content>
                <mat-dialog-actions>
                    <div class="dialog-actions-right">
                        <button class="button--secondary-small" mat-button (click)="CloseDialog(false)">{{content?.warningList[0]?.cancelCTAText}}</button>
                        <button class="button--primary-small" mat-button (click)="CloseDialog(true)">{{content?.warningList[0]?.confirmCTAText}}</button>
                    </div>
                </mat-dialog-actions>
            </div>
        </div>
    </div>
</ng-template>